import React from 'react';
import { Grid, LeftColumnGridCell, RightColumnGridCell } from 'styles';
import { copyFor } from 'config';
import SolarPanels from '/images/solar/single-solar-panel.svg';
import { PageHeading } from 'components/page-heading';
import { ProjectDetails } from 'pages/solar/components/project-details';
import { CanceledStatus } from 'pages/solar/components/canceled-status';
import { ReconnectUtilityNotification } from 'pages/solar/components/reconnect-utility-notification';

const getProjectDetailsCopy = copyFor('solar.projectDetails.canceled');

export const Canceled = ({
  stateFullName,
  pageHeading,
}: SolarActiveViewProps) => {
  const projectDetailProps = {
    location: getProjectDetailsCopy('location', {
      state: stateFullName,
    }),
    mdIdentifier: null,
    svgSrc: SolarPanels,
    title: getProjectDetailsCopy('title'),
  };

  return (
    <>
      <PageHeading page={pageHeading} />
      <ReconnectUtilityNotification />
      <Grid width="100%" gap="24px">
        <LeftColumnGridCell>
          <CanceledStatus />
        </LeftColumnGridCell>
        <RightColumnGridCell>
          <ProjectDetails {...projectDetailProps} />
        </RightColumnGridCell>
      </Grid>
    </>
  );
};
